// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"badbe757","455":"54617a4c"}[chunkId] + ".chunk.js";
};